import { onError } from 'apollo-link-error'
import * as log from 'loglevel'
import store from '@/store'
import { Message } from 'element-ui'
import Raven from 'raven-js'

import $router from '@/router'

const link = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    log.debug('GraphQL error encountered. Checking auth validity before reporting')
    store.dispatch('Auth/checkExpiration').then(() => {
      graphQLErrors.forEach(({ message, path }) => {
        Raven.captureMessage(`graphQLError: ${message}`)
        if (!path || !path.length) {
          // eslint-disable-next-line
          console.log('graphQLError', message, path)
          return
        }

        switch (path[0]) {
          case 'auditDetails':
          case 'auditReview': {
            $router.push('/audits')
            // eslint-disable-next-line
            Message({
              message: `GraphQL Error: ${message}`,
              type: 'error',
              duration: '15000', // Extended duration for Manila to screenshot
            })
            break
          }
          default: {
            // eslint-disable-next-line
            console.log('graphQLError', message, path);
          }
        }
      })
    })
  }

  if (networkError) {
    log.debug('Network error encountered')
    Message({
      duration: 8000,
      message: 'Network error. Please check your network connection or refresh the page.',
      type: 'info',
      center: 'false',
    })
  }
})

export default link



// WEBPACK FOOTER //
// ./src/graphql/error/index.js